import './App.css';
import React,{useState,useEffect} from 'react'
import {FormControl,Select,MenuItem} from '@material-ui/core'
import InfoBox from './infobox'
import Map from './map.js'
import Table from './table.js'
import {sortData }from './util.js'
import LineGraph from './linegraph.js'
import {Card ,CardContent,Typography} from '@material-ui/core'
import {prettyPrintStat} from './util.js'
import 'leaflet/dist/leaflet.css'
function App() {
  // eslint-disable-next-line
  const[countires,setCountries]=useState([]);
  const[country,setCountry]=useState(["worldwide"]);
  const [countryInfo,setCountryInfo]=useState([]);
  const [tableData ,setTableData]=useState([]);
 const [caseType,setCaseType]=useState(["cases"]);
const [mapCenter,setMapCenter]=useState([34.80746
,-40.4796]);
const [mapZoom,setMapZoom]=useState(4)
 const[mapCountries,setMapCountries]=useState([])
useEffect(()=>{
  const getCountriesData= async ()=>{

     await fetch('https://disease.sh/v3/covid-19/countries').then((response)=>response.json()).
     then((data)=>
       {
        
        const countries =data.map((country)=>(
          {
            name:country.country,
            value:country.countryInfo.iso2
          }
        ))
        const sortedData=sortData(data)
        setCountries(countries);
        setTableData(sortedData) 
        setMapCountries(data)
      
 


       }
     )


  }

getCountriesData();

},[])

const onCountryChange=async (event)=>{

const countryCode = event.target.value;

const url = countryCode==="worldwide"?`https://disease.sh/v3/covid-19/all`:`https://disease.sh/v3/covid-19/countries/${countryCode}`
await fetch(url).then((response)=>response.json()).then((data)=>{
  setCountry(countryCode)
setCountryInfo(data);
countryCode === "worldwide"
? setMapCenter([34.80746, -40.4796])
: setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
setMapZoom(4);

})
console.log(countryInfo)
}

  return (
    <div className="app">
      <div class="app_left"> 
      <div className="app_header">
           <h1 className="head">Covid-19 Tracker</h1>
            <FormControl className="app_dropdown">
                 <Select variant="outlined" onChange={onCountryChange} value={country}>
                 <MenuItem value="worldwide">WorldWide</MenuItem>
                  
                   {
                     countires.map((country)=>(
                      <MenuItem value={country.value}>{country.name}</MenuItem>
                     ))
                 
                   }{/* <MenuItem value="US">US</MenuItem>
                   <MenuItem value="UK">UK</MenuItem>  */}
                 </Select>
            </FormControl>
      </div>
             <div className="app_stats">
                <InfoBox isRed={1} active={caseType==="cases"}  onClick={e=>setCaseType("cases")}     title="Coronavirus Cases"  cases={prettyPrintStat(countryInfo.todayCases)} total={countryInfo.cases}/>
                <InfoBox isRed={0} active={caseType==="recovered"}  onClick={e=>setCaseType('recovered')} title="Recovered" total={countryInfo.recovered} cases={prettyPrintStat(countryInfo.todayRecovered)} />
                <InfoBox isRed={1}active={caseType==="deaths"}  onClick={e=>setCaseType('deaths')} title="Deaths" total={countryInfo.deaths} cases={prettyPrintStat(countryInfo.todayDeaths)}/>
             </div>

             <Map countries={mapCountries} center={mapCenter}
              zoom={mapZoom} caseType={caseType}/>
      </div>

     <div className="app_right">
            <Card>
                 <h1>Worldwide cases of Coronavirus</h1>
                <Table   countries={tableData}> </Table>


            </Card>
            <h2 className="app_graph_title">Worldwide new {caseType}</h2>
            <LineGraph className="app_graph" caseType={caseType}/>
     </div>


             
    </div>
  );
}

export default App;
